// extracted by mini-css-extract-plugin
export default {"dialog":"dialog_dialog__yUT6x","positionedDialog":"dialog_positionedDialog__QHIjv"};